export default __webpack_public_path__ + "static/media/violaine.e123917d.jpg";